import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

// Стрелки обмена из макета: две встречные стрелки
export function AppIconSwapArrows({ size = 24, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_ICON_BRAND

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        fill={fill}
        d="M5.32512 3.4707C5.86129 3.03346 6.63559 3.03352 7.1718 3.4707L7.28313 3.57129L9.88664 6.1748C10.2381 6.52625 10.238 7.09677 9.88664 7.44824C9.53527 7.79941 8.96561 7.79931 8.61418 7.44824L7.14934 5.98242V16.0039C7.14934 16.5008 6.74578 16.904 6.24895 16.9043C5.75189 16.9043 5.34856 16.501 5.34856 16.0039V5.98242L3.88371 7.44824C3.53225 7.79969 2.96174 7.79968 2.61027 7.44824C2.25881 7.09678 2.25882 6.52628 2.61027 6.1748L5.21379 3.57129L5.32512 3.4707ZM13.7529 3.09766C14.2499 3.09768 14.6532 3.50101 14.6532 3.99805V14.0176L16.1181 12.5527C16.4695 12.2016 17.0392 12.2015 17.3905 12.5527C17.7419 12.9042 17.742 13.4747 17.3905 13.8262L14.787 16.4297C14.2159 17.0008 13.29 17.0005 12.7187 16.4297L10.1142 13.8262C9.76272 13.4747 9.76273 12.9042 10.1142 12.5527C10.4657 12.2013 11.0361 12.2013 11.3876 12.5527L12.8525 14.0176V3.99805C12.8525 3.501 13.2558 3.09766 13.7529 3.09766Z"
      />
    </Svg>
  )
}
